import { FC } from 'react';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { Title } from '#components/title';
import modelDetailCss from '../assets/model-detail/model-detail.module.scss';

const H1: FC = () => {
  const {
    advert: {
      name,
    },
  } = useAdvertDetailContext();

  return (
    <Title
      title={name}
      isDisplayAsH1
      textCenter={false}
      additionalClassName={modelDetailCss.modelDetail__title}
    />
  );
};

export { H1 };
